<template>
  <div class="input checkbox-input" :class="{checked: checked}" @click="toggle">
    <div class="checkbox--container">
      <div class="checked-status"></div>
    </div>
    <div class="checkbox--label" v-if="label && htmlNeeded" v-html="label">
    </div>
    <div class="checkbox--label" v-if="label && !htmlNeeded" v-html="label">
      {{label}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkbox-input',
  props: {
    label: String,
    defaultChecked: Boolean,
    htmlNeeded: Boolean,
    value: Boolean
  },
  watch: {
    defaultChecked(o) {
      this.checked = o;
    },
    value(val)  {
      if (val) return this.check();
      return this.unchecked();
    }
  },
  mounted() {
    if (this.$props.defaultChecked) {
      this.$data.checked = true;
      this.$emit('input', this.$data.checked);
    }
  },
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    check() {
      this.checked = true;
      this.$emit('input', true);
    },
    unchecked() {
      this.checked = false;
      this.$emit('input', false);
    },
    toggle() {
      this.checked = !this.checked;
      this.$emit('input', this.checked);
    },
  },
};
</script>

<style scoped>

  .orange {
    color: var(--orange);
    transition: All 0.3s ease-in-out;
    -webkit-transition: All 0.3s ease-in-out;
    -moz-transition: All 0.3s ease-in-out;
    -o-transition: All 0.3s ease-in-out;
    -ms-transition: All 0.3s ease-in-out;
  }

  a {
    text-decoration: none;
    color: var(--darker-orange);
  }


  .checkbox-input {
    display: flex;
    flex-wrap: nowrap;
    cursor: pointer;
    margin-top: 20px;
  }
  .checkbox-input .checkbox--container {
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
    margin: auto 1rem auto 0;
    background: var(--white);
    position: relative;
    border: 1px solid var(--black);
  }
  .checkbox-input .checkbox--container .checked-status {
    position: absolute;
    top: 5px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    background: var(--darker-orange);
    transform: scale(0);
    transition: all 300ms ease;
  }
  .checkbox-input.checked .checkbox--container .checked-status {
    transform: scale(1);
  }
  .checkbox-input .checkbox--label {
    flex: 1 1 auto;
    margin: auto auto auto 0;
    line-height: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/checkbox-input.vue